<template>
  <section id="downloads" class="downloads-section">
    <BackgroundImage
      class="container-fluid downloads-section__background"
      :src="backgroundImgDownloads"
      styles="min-height: 56vw;"
    >
      <div class="container text-center">
        <div class="row ">
          <News />
          <Downloads />
        </div>
      </div>
    </BackgroundImage>
  </section>
</template>

<script>
import News from "./News";
import Downloads from "./Downloads";
import BackgroundImage from "@/components/BackgroundImage";
export default {
  name: "DownloadsSection",
  components: {
    News,
    Downloads,
    BackgroundImage
  },
  computed: {
    backgroundImgDownloads() {
      return this.$store.getters.image_background_downloads;
    }
  }
};
</script>

<style scoped>
@media (max-width: 575.98px) {
  .downloads-section__background {
    background-image: none !important;
  }
}
</style>
